if (!customElements.get('size-chart-dialog')) {
  class SizeChartDialog extends HTMLElement {
    constructor() {
      super();

      this.dialog = this.querySelector('.gx-size-chart__dialog');
      this.openButton = this.querySelector('[data-size-chart-open]');
      this.closeButton = this.querySelector('[data-size-chart-close]');

      this.bodyWasLocked = false;

      this.openDialog = this.openDialog.bind(this);
      this.closeDialog = this.closeDialog.bind(this);
      this.handleBackdropClick = this.handleBackdropClick.bind(this);
      this.handleCancel = this.handleCancel.bind(this);
      this.handleClosed = this.handleClosed.bind(this);
    }

    connectedCallback() {
      if (!this.dialog || !this.openButton || !this.closeButton) return;

      this.openButton.addEventListener('click', this.openDialog);
      this.closeButton.addEventListener('click', this.closeDialog);
      this.dialog.addEventListener('click', this.handleBackdropClick);
      this.dialog.addEventListener('cancel', this.handleCancel);
      this.dialog.addEventListener('close', this.handleClosed);
    }

    disconnectedCallback() {
      if (!this.dialog || !this.openButton || !this.closeButton) return;

      this.openButton.removeEventListener('click', this.openDialog);
      this.closeButton.removeEventListener('click', this.closeDialog);
      this.dialog.removeEventListener('click', this.handleBackdropClick);
      this.dialog.removeEventListener('cancel', this.handleCancel);
      this.dialog.removeEventListener('close', this.handleClosed);

      if (this.dialog.open) {
        this.dialog.close();
      }
    }

    openDialog() {
      if (!this.dialog || this.dialog.open) return;

      this.bodyWasLocked =
        document.body.classList.contains('overflow-hidden');

      document.body.classList.add('overflow-hidden');

      this.dialog.showModal();

      requestAnimationFrame(() => {
        this.closeButton.focus({ preventScroll: true });
      });
    }

    closeDialog() {
      if (!this.dialog || !this.dialog.open) return;

      this.dialog.close();
    }

    handleCancel(event) {
      event.preventDefault();
      this.closeDialog();
    }

    handleBackdropClick(event) {
      if (event.target === this.dialog) {
        this.closeDialog();
      }
    }

    handleClosed() {
      /*
       * Agar Quick Add ya koi doosra modal pehle se body lock use kar raha tha,
       * to Size Chart close hone par us lock ko remove nahi karna.
       */
      if (!this.bodyWasLocked) {
        document.body.classList.remove('overflow-hidden');
      }

      this.bodyWasLocked = false;

      if (this.openButton?.isConnected) {
        this.openButton.focus({ preventScroll: true });
      }
    }
  }

  customElements.define('size-chart-dialog', SizeChartDialog);
}